import { IBenefitDTO } from '../../dto/benefits/benefit.dto';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';

const benefitDTOs: IBenefitDTO[] = [
  {
    title: $localize`:@@page-photo-downloader-content-benefits-section-option-0-title:Ease to use`,
    value: $localize`:@@page-photo-downloader-content-benefits-section-option-0-value:Our Instagram photo downloader is designed with user-friendliness in mind. Simply input the Instagram post link, and the tool will handle the rest, making it effortless to download Instagram photos.`,
  },
  {
    title: $localize`:@@page-photo-downloader-content-benefits-section-option-1-title:No account required`,
    value: $localize`:@@page-photo-downloader-content-benefits-section-option-1-value:Enjoy the convenience of downloading photos from Instagram without the need for any account creation or log in. Our tool respects your privacy and ensures a hassle-free experience.`,
  },
  {
    title: $localize`:@@page-photo-downloader-content-benefits-section-option-2-title:High-quality downloads`,
    value: $localize`:@@page-photo-downloader-content-benefits-section-option-2-value:Preserve the quality of your images with our downloader. Whether it's a high-resolution photo or a stunning image from Instagram, our service ensures you get the best quality possible when you download Instagram photos.`,
  },
  {
    title: $localize`:@@page-photo-downloader-content-benefits-section-option-3-title:Instant access`,
    value: $localize`:@@page-photo-downloader-content-benefits-section-option-3-value:Save time with instant downloads. Our tool processes your request quickly so you can get your desired Instagram photos without delay.`,
  },
  {
    title: $localize`:@@page-photo-downloader-content-benefits-section-option-4-title:Download multiple Instagram photos`,
    value: $localize`:@@page-photo-downloader-content-benefits-section-option-4-value:Need to save more than one image? Our tool allows you to download multiple Instagram photos in one go, making it a practical choice for bulk image saving.`,
  },
];

export const benefitsDTO: IBenefitsDTO = {
  title: $localize`:@@page-photo-downloader-content-benefits-section-title:The essential benefits of our Instagram photo downloader`,
  benefits: benefitDTOs,
};
